module.exports = __webpack_public_path__ + "static/media/Bangkok.a18873d8.jpg";